import { jsx as _jsx } from "react/jsx-runtime";
import { Form } from "antd";
import { observer } from "mobx-react";
import { CUSTOMER_TYPE_FIELD } from "./CustomerTypeSwitch.js";
import { CustomerTermsSection } from "../../../../components/customerTermsSection.js";
import { useStores } from "../../../../store/stores.js";
/**
 * Resolves the customer type from the surrounding `Form` watcher and pulls
 * seller, manufacturer, and additional-teachings inputs from the Checkout V2
 * store, then delegates the legal-acknowledgement rendering to
 * `CustomerTermsSection`.
 */ const TeachingsSection = observer(()=>{
    const { checkoutV2Store } = useStores();
    const customerType = Form.useWatch(CUSTOMER_TYPE_FIELD);
    const { product } = checkoutV2Store;
    if (!product) {
        return null;
    }
    return /*#__PURE__*/ _jsx(CustomerTermsSection, {
        customerType: customerType,
        seller: product.seller,
        manufacturer: product.manufacturer,
        additionalTeachings: product.data.productPlan.additionalTeachings ?? []
    });
});
export { TeachingsSection };
